import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Loader2, Building2, CheckCircle2, AlertTriangle } from "lucide-react";

export default function TenantAccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setError("Missing access token."); return; }
    (async () => {
      try {
        const { data } = await api.post("/tenant/magic-login", { token });
        await loginWithToken(data.token);
        setStatus("ok");
        setTimeout(() => navigate("/app/tenant"), 700);
      } catch (e) {
        setStatus("error");
        setError(e.response?.data?.detail || "This access link is invalid or expired.");
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6" data-testid="tenant-access-page">
      <div className="max-w-md w-full text-center">
        <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center mx-auto mb-6"><Building2 className="w-7 h-7 text-white" /></div>
        {status === "loading" && <><Loader2 className="w-6 h-6 animate-spin text-blue-400 mx-auto" /><p className="mt-4 text-slate-300">Verifying your maintenance portal access…</p></>}
        {status === "ok" && <><CheckCircle2 className="w-8 h-8 text-emerald-400 mx-auto" /><p className="mt-4 text-slate-200">Access granted. Redirecting…</p></>}
        {status === "error" && (
          <><AlertTriangle className="w-8 h-8 text-amber-400 mx-auto" /><p className="mt-4 text-slate-200" data-testid="tenant-access-error">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-6 text-sm text-blue-400 hover:text-blue-300 underline">Go to login</button></>
        )}
      </div>
    </div>
  );
}
